import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import DocumentTitle from 'react-document-title';
import './index.less';

const logo = require('@/assets/image/ext/insurance/logo.png');
const analyse = require(`@/assets/image/ext/insurance/analyse.png`);
const iconAb = require(`@/assets/image/ext/insurance/icon_ab.png`);
const charts = [
    require(`@/assets/image/ext/insurance/chart1.png`),
    require(`@/assets/image/ext/insurance/chart2.png`),
    require(`@/assets/image/ext/insurance/chart3.png`)
];
const certs = [
    require(`@/assets/image/ext/insurance/cert1.png`),
    require(`@/assets/image/ext/insurance/cert2.png`)
];
const intros = [
    '阿拉丁保险经纪有限公司是一家全国性专业保险经纪公司，注册资本5000万元人民币，总部位于北京。秉承“专业、谨慎、诚信、客观”的企业理念，阿拉丁保险经纪致力于打造业内高品质的保险服务专业平台，立足本土，为中国高净值家庭提供综合型保险金融服务。',
    '团队成员主要来自银行、保险、信托、券商等大资管行业的销售精英，精通金融行业知识与技能，有丰富的服务高净值客户的经验。团队围绕高净值客户中端需求（养老、子女规划）、高端需求（传承安排、债务隔离、婚姻风险、税务筹划等），结合保险独特的法律属性和功能，透过保险架构搭建，为客户提供专业的建议及解决方案。',
    '公司核心业务围绕中高净值客户需求，提供专业建议及解决方案。用专业、独立、客观的筛选标准，与众多保险公司合作，产品涵盖人身保险、意外保险、养老保险、健康保险及高端医疗等。通过定制专业合理的保险方案，帮助客户进行全面风险保障规划。'
];
function News() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [newsContent, setNewsContent] = useState(<div className='news'>666</div>);
    function getNewsHyzx() {
        setNewsContent(<div className='news'>
            <h3>惠民保再战2022：亿级用户下的剧烈调整，多方诉求何以平衡？</h3>
            <p>近期以来，上海疫情意外发展、各地疫情反反复复，原本热闹的惠民保好像突然安静了下来。</p>
            <p>事实上，安静的表象下，急流涌动。如同今年疫情变幻多端一般，进入第三个高速增长年头的惠民保，在保险产品形态、政府部门态度、保险公司布局和平台方格局等方面，都在发生疾风骤雨般的变化。</p>
            <p>伴随上层建筑和地方政府的日趋关注，席卷200多个地级市，累计参保过亿人次的惠民保项目，将在2022年走向何方？</p>
            <p>2022开年四重变化</p>
            <p>价格责任调整叠加政府重新定位</p>
            <p>省版崛起平台回归理性</p>
            <p>2022年的惠民保发展呈现出与以往不同的新特点——</p>
            <p>第一重：产品价格微调  责任升级迭代</p>
            <p>作为较早推出针对上海市基本医保参保人的沪惠保，曾一经推出全国瞩目，起到了对其他地方的引领和示范作用。但运行实践发现，上海沪惠保并不乐观，2021年7月-9月的赔付支出翻了4倍。</p>
            <p>据悉，2022版上海沪惠保将计划调整产品责任，价格应该也会上浮。其实不仅是上海，全国各地都在筹划惠民保产品调整，价格微调、责任升级将成为今年惠民保的特点。</p>
            <p>第二重：政府重新定位  持续关注理赔</p>
            <p>惠民保无疑应该属于政府工程，没有政府的参与支持，无法开展。但政府在整个项目中的位置各地并不相同。</p>
            <p>比如，广东地市政府纷纷深度参与惠民保，此前人保财险运作的商业型惠民保，正过度到政府指导型惠民保。</p>
            <p>东莞市民保已被东莞莞家福所替代，受疫情波动和价格上涨等多重因素，今年莞家福保单销量比较平淡。</p>
            <p>山东省医保局持续关注各地市理赔情况，前后已经进行多次项目理赔运营情况调研，近期可能会出台相关指导性文件。</p>
            <p>第三重：地市版犹在酣战  省级版悄然崛起</p>
            <p>截至2022年4月，全国已有 200 多个地级市先后开展了惠民保项目，累计参保超1.3亿人次。</p>
            <p>相比于热闹的地市市场，偏商业属性的全省版惠民保也逐渐走红，湖南爱民保、安徽皖惠保、河北冀惠保、江苏医惠保1号、吉林吉康保、燕赵健康保等纷沓而至，其中不乏有的项目参保人数超过百万、参保率超过5%，甚至给人以省版将会一统全国地市的感觉。</p>
            <img src={analyse} className='pic' />
            <p>（第三方平台功能解析图）</p>
            <p>第四重：第三方平台回归理性 竞争热度明显下降</p>
            <p>去年惠民保第三方平台竞争白热化，甚至在个别区域出现价格战，经历了市场躁动之后今年集体回归理性。</p>
            <p>暖哇科技退出惠民保市场，镁信健康开始侧重特药服务。平安医保科技和360保险科技，则受自身业务调整而退出市场。</p>
        </div>);
    }
    function getNewsBxsj() {
        setNewsContent(<div className='news'>
            <h3>2022年一季度保险业实现原保费收入1.78万亿元</h3>
            <p>近日，银保监会公布保险业经营情况数据显示，截至3月末保险业实现原保险保费收入1.78万亿元。其中，人身险业务累计实现原保费收入1.46万亿元；财产险业务累计实现原保费收入3246亿元。</p>
            <img src={charts[0]} className="pic" />
            <p>从公司层面看，截至今年3月末，人身险公司实现原保费收入1.36万亿元，其中，寿险原保费收入1.1万亿元、意外险原保费收入147亿元、健康险原保费收入2358亿元。财产险公司实现原保费收入4226亿元，其中车险原保费收入达1965亿元。</p>
            <img src={charts[1]} className="pic" />
            <img src={charts[2]} className="pic" />
        </div>);
    }
    const news = [
        {
            title: '行业资讯',
            action: index => {
                setActiveIndex(index);
                getNewsHyzx();
            }
        },
        {
            title: '保险数据',
            action: index => {
                setActiveIndex(index);
                getNewsBxsj();
            }
        }
    ];
    useEffect(() => {
        getNewsHyzx();
    }, []);
    return <div className='news-wrap'>
        <ul className='news-list'>
            {news.map((o, index) => <li key={index}
                className={activeIndex === index ? 'active' : ''}
                onClick={() => o.action(index)}>{o.title}</li>)}
        </ul>
        {newsContent}
    </div>;
}
function Insurance() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [content, setContent] = useState(<div></div>);
    const getSy = () => {
        setContent(<div className='content'>
            <News />
        </div>);
    }
    function getGywm() {
        setContent(<div className='content'>
            {intros.map((intro, index) => <p key={index}>{intro}</p>)}
        </div>);
    }
    function getXxpl() {
        setContent(<div className='content'>
            <p>一、法定名称及缩写</p>
            <p>公司中文名称：阿拉丁保险经纪有限公司</p>
            <p>品牌：阿拉丁保险经纪</p>
            <br />

            <p>二、注册资本</p>
            <p>5000万元</p>
            <br />

            <p>三、注册地</p>
            <p>北京市朝阳区建国路77号35层座3501内01L单元</p>
            <br />

            <p>四、成立时间</p>
            <p>2003-06-18</p>
            <br />

            <p>五、经营范围</p>
            <p>许可项目：在全国区域内（港、澳、台除外）为投保人拟订投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国银保监会批准的其他业务。</p>
            <br />

            <p>六、法定代表人</p>
            <p>孙伟然</p>
            <br />

            <p>七、证件信息</p>
            <img src={certs[0]} className='pic' />
            <img src={certs[1]} className='pic' />
        </div>);
    }
    const navList = [
        {
            title: '首页',
            action(index) {
                setActiveIndex(index);
                getSy();
            }
        },
        {
            title: '网销商城',
            action() {
                window.open('https://www.zhibaocloud.com');
            }
        },
        {
            title: '关于我们',
            action(index) {
                setActiveIndex(index);
                getGywm();
            }
        },
        {
            title: '信息披露',
            action(index) {
                setActiveIndex(index);
                getXxpl();
            }
        }
    ];
    function getNav() {
        return <ul className='nav'>
            <li>
                <img src={logo} className='logo' />
            </li>
            {navList.map((nav, index) => <li key={index}
                onClick={() => nav.action(index)}
                className={activeIndex === index ? 'active' : ''}>
                {nav.title}</li>)}
        </ul>
    }
    function getFooter() {
        return <ul className='footer'>
            <li>
                <h1>联系我们</h1>
                <p>阿拉丁保险经纪有限公司</p>
                <p>电话：010-51392686</p>
                <p>地址：北京市朝阳区建国路77号35层</p>
            </li>
            <li>
                <h1>协议</h1>
                <p><a href="http://jira.dangdang-operate.com/secure/attachment/21976/%E9%98%BF%E6%8B%89%E4%B8%81%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE.docx">《用户协议》</a></p>
                <p><a href="http://jira.dangdang-operate.com/secure/attachment/21977/%E9%98%BF%E6%8B%89%E4%B8%81%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E4%BF%9D%E6%8A%A4%E8%AF%B4%E6%98%8E.docx">《隐私保护说明》</a></p>
            </li>
        </ul>
    }
    useEffect(() => {
        getSy();
    }, []);
    return <DocumentTitle title='阿拉丁保险经纪'>
        <main>
            {getNav()}
            <div className='bd'>
                {content}
                {getFooter()}
                <div className='icp'>
                    <a href='https://beian.miit.gov.cn/' target='_blank'>京ICP备2022029822号</a>
                    <div className='jgwab'>
                        <a target="_blank"
                            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502051226" >
                            <img src={iconAb} />
                            <p>京公网安备 11010502051226号</p>
                        </a>
                    </div>
                </div>
            </div>
        </main>
    </DocumentTitle>;
}

export default Insurance;